import { render, staticRenderFns } from "./CopyResultsTable.vue?vue&type=template&id=aaa09aac&scoped=true&"
import script from "./CopyResultsTable.vue?vue&type=script&lang=ts&"
export * from "./CopyResultsTable.vue?vue&type=script&lang=ts&"
import style0 from "./CopyResultsTable.vue?vue&type=style&index=0&id=aaa09aac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa09aac",
  null
  
)

export default component.exports